import type * as React from "react";
import { Box, ButtonBase, Typography } from "@mui/material";
import ShareGenomicLifeOptionsModal from "components/v3/pages/account/PlanInformationPage/ShareGenomicLifeOptionsModal";
import { getTellOthersDashboardBarHeadline, shouldShowInviteFriendsDashboardBar } from "components/v3/pages/account/PlanInformationPage/tellOthersGenomicLifeUtils";
import { useTellOthersShareFlow } from "components/v3/pages/account/PlanInformationPage/useTellOthersShareFlow";
import { COLORS } from "components/v3/Theme/colors";

const InviteFriendsDashboardBar: React.FC = () => {
  const {
    closeShareOptionsModal,
    copy,
    eligibility,
    handlePrimaryClick,
    isMemberActive,
    shareOptionsModalOpen
  } = useTellOthersShareFlow({ ctaLocation: "dashboard_card" });

  if (!shouldShowInviteFriendsDashboardBar(isMemberActive, eligibility)) {
    return null;
  }

  const headline = getTellOthersDashboardBarHeadline(eligibility);

  return (
    <>
      <ShareGenomicLifeOptionsModal
        open={shareOptionsModalOpen}
        onClose={closeShareOptionsModal}
      />
      <Box sx={{ paddingX: 2 }}>
        <ButtonBase
          aria-label={`${headline}. ${copy.message}`}
          data-testid="invite-friends-dashboard-bar"
          focusRipple
          onClick={handlePrimaryClick}
          sx={{
            alignItems: "stretch",
            backgroundColor: COLORS.ACCENT3_LIGHTER,
            borderRadius: "8px",
            boxSizing: "border-box",
            display: "block",
            overflow: "hidden",
            position: "relative",
            textAlign: "left",
            transition: "filter 0.2s ease",
            width: "100%",
            "&:hover": {
              filter: "brightness(0.98)"
            },
            "&:focus-visible": {
              outline: `2px solid ${COLORS.ACCENT3_DARK}`,
              outlineOffset: 2
            }
          }}
        >
          <Box
            aria-hidden
            sx={{
              height: 72,
              left: 0,
              overflow: "hidden",
              pointerEvents: "none",
              position: "absolute",
              top: 0,
              width: 72
            }}
          >
            <Box
              sx={{
                backgroundColor: COLORS.ACCENT3_DARK,
                left: "33%",
                position: "absolute",
                py: 0.375,
                textAlign: "center",
                top: 11,
                transform: "translateX(-50%) rotate(-45deg)",
                width: 96
              }}
            >
              <Typography
                component="span"
                sx={{
                  color: COLORS.WHITE,
                  fontSize: "14px",
                  fontWeight: 700,
                  letterSpacing: "0.04em",
                  lineHeight: 1
                }}
              >
                NEW!
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              pl: { md: 5, xs: 4 },
              pr: 3,
              py: 3
            }}
          >
            <Typography
              component="h2"
              variant="body_strong_lg_black"
              sx={{
                alignItems: "center",
                display: "flex",
                flexWrap: "wrap",
                gap: 1,
                margin: 0
              }}
            >
              <Box aria-hidden component="span" sx={{ lineHeight: 1 }}>
                🥰
              </Box>
              {headline}
            </Typography>
            <Typography component="p" sx={{ margin: 0 }} variant="body">
              {copy.message}
            </Typography>
          </Box>
        </ButtonBase>
      </Box>
    </>
  );
};

export default InviteFriendsDashboardBar;
